module.exports = __webpack_public_path__ + "img/picto-messages.8de2f5a3.svg";